import CycleTimeMonitoringDataViewer from './CycleTimeMonitoringDataViewer'

export default {
  install( molten ) {
    molten.addPlugin( 'DataViewer', CycleTimeMonitoringDataViewer )
  }
}
